/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { Product } from "../types";
import { API } from "./base";

const api = new API();

/**
 * Hits the `#[Route('{uid}/products')]` in the Shop controller in TheyStay/API returning
 * a list of Products belonging to the provided entity.
 */
export async function getProducts(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/shop/${entity_uid}/products`,
    });

    return res.items as Product[];
}

/**
 * Hits the `#[Route('order/{uid}/order-create')]` in the OrderApiController in TheyStay/API
 * which does server-side validation on the supplied data then does database transaction
 */
export async function createNewOrder(form: any) {
    let {base_entity_uid} = api.config;

    const res = await api.call({
        method: 'POST',
        endpoint: `/order/${base_entity_uid}/order-create`,
        body: form,
    });

    return res;
}
